export enum BrandCartsSortBy {
  BRAND_CARTS_SORT_BY_UNKNOWN = 'BRAND_CARTS_SORT_BY_UNKNOWN',
  UPDATED_AT = 'UPDATED_AT',
}
